export default {
    default: "System error, service unavaliable.",
    'IT-500': "Can not find the api configuration。",
    404: "Api router not found."
};